import React, {
  ComponentProps,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { Text } from "../common";
import { translateText } from "../../utils/string.utils";

const TranslatedText: React.FC<
  PropsWithChildren<ComponentProps<typeof Text>>
> = ({ children: sourceText, ...props }) => {
  const { i18n } = useTranslation();
  const [translatedText, setTranslatedText] = useState<string>(
    sourceText as string
  );

  useEffect(() => {
    i18n.language.toLowerCase() === "pt-br"
      ? setTranslatedText(sourceText as string)
      : translateText(sourceText as string, i18n.language).then(
          setTranslatedText
        );
  }, [i18n.language, sourceText]);

  return <Text {...props}>{translatedText}</Text>;
};

export default TranslatedText;
